import { render, staticRenderFns } from "./kode_puskesmas.vue?vue&type=template&id=5b68f9bc&"
import script from "./kode_puskesmas.vue?vue&type=script&lang=js&"
export * from "./kode_puskesmas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports